(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["medicine-row-statements"] && !Shopify.designMode) return;
  try {
    if (!window.heySisterMedicineRows) {
    window.heySisterMedicineRows = true;
    const states = new WeakMap();
    const pending = new Set();
    let frame = 0;
    let nextId = 0;

    const restore = (grid, state) => {
      state.statements.forEach(statement => statement.remove());
      state.statements = [];
      grid.classList.remove('product-list__inner--medicine-rows');
      grid.style.removeProperty('--medicine-row-columns');
      Array.from(grid.children).forEach(card => {
        const fallback = card.querySelector('.medicine-card-copy__mandatory');
        if (fallback) fallback.hidden = false;
        const descriptions = (card.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && !id.startsWith('medicine-row-statement-'));
        if (descriptions.length) card.setAttribute('aria-describedby', descriptions.join(' '));
        else card.removeAttribute('aria-describedby');
      });
    };

    const update = grid => {
      const state = states.get(grid);
      if (!state || !grid.isConnected || !grid.getClientRects().length || !grid.clientWidth) return;
      const cards = Array.from(grid.children).filter(child => child.matches('product-item') && child.getClientRects().length && !child.hidden);
      const signature = [grid.clientWidth, getComputedStyle(grid).gridAutoFlow, getComputedStyle(grid).getPropertyValue('--section-products-per-row'), ...cards.map(card => card.querySelector('a[href]')?.getAttribute('href') || '')].join('|');
      const sameCards = cards.length === state.cards.length && cards.every((card, index) => card === state.cards[index]);
      const statementsConnected = state.statements.every(statement => statement.isConnected);
      if (signature === state.signature && sameCards && statementsConnected) return;
      restore(grid, state);
      state.signature = null;
      state.cards = cards;
      const medicines = cards.filter(card => card.querySelector('.medicine-card-copy__mandatory'));
      if (!medicines.length) { state.signature = signature; return; }
      const fallback = medicines[0].querySelector('.medicine-card-copy__mandatory');
      const text = fallback.textContent.trim();
      if (!text) return;
      const carousel = getComputedStyle(grid).gridAutoFlow.includes('column');
      medicines.forEach(card => { card.querySelector('.medicine-card-copy__mandatory').hidden = true; });
      const rows = [];
      if (carousel) rows.push(cards);
      else {
        const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(value => parseFloat(value) > 0);
        if (!columns.length) { restore(grid, state); return; }
        grid.style.setProperty('--medicine-row-columns', columns.join(' '));
        grid.classList.add('product-list__inner--medicine-rows');
        cards.forEach(card => {
          const top = card.offsetTop;
          let row = rows.find(items => Math.abs(items[0].offsetTop - top) < 2);
          if (!row) { row = []; rows.push(row); }
          row.push(card);
        });
      }
      rows.forEach(row => {
        const rowMedicines = row.filter(card => medicines.includes(card));
        if (!rowMedicines.length) return;
        const statement = document.createElement('p');
        statement.className = 'medicine-row-statement' + (carousel ? ' medicine-row-statement--carousel' : '');
        statement.id = 'medicine-row-statement-' + (++nextId);
        statement.textContent = text;
        if (carousel) {
          const list = grid.closest('product-list');
          const footer = list.querySelector('.section__footer');
          if (footer) footer.before(statement);
          else list.append(statement);
        }
        else row[row.length - 1].after(statement);
        state.statements.push(statement);
        rowMedicines.forEach(card => {
          const descriptions = (card.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          card.setAttribute('aria-describedby', [...descriptions, statement.id].join(' '));
          if (!card.hasAttribute('role')) card.setAttribute('role', 'group');
          if (!card.hasAttribute('aria-label')) card.setAttribute('aria-label', card.querySelector('.product-item-meta__title')?.textContent.trim() || '');
        });
      });
      state.signature = signature;
    };

    const schedule = grid => {
      pending.add(grid);
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        pending.forEach(grid => {
          try { update(grid); }
          catch { const state = states.get(grid); if (state) { restore(grid, state); state.signature = null; } }
        });
        pending.clear();
      });
    };
    const resize = new ResizeObserver(entries => entries.forEach(entry => schedule(entry.target)));
    const discover = root => {
      if (!(root instanceof Element || root instanceof Document)) return;
      const grids = Array.from(root.querySelectorAll('.product-list__inner'));
      if (root.matches?.('.product-list__inner')) grids.push(root);
      grids.forEach(grid => {
        if (!states.has(grid)) { states.set(grid, { statements: [], cards: [], signature: null }); resize.observe(grid); }
        schedule(grid);
      });
    };
    const start = () => {
      discover(document);
      new MutationObserver(records => {
        records.forEach(record => {
          const grid = record.target.closest?.('.product-list__inner');
          if (grid) schedule(grid);
          if (record.type === 'attributes') discover(record.target);
          record.addedNodes.forEach(node => discover(node));
          record.removedNodes.forEach(node => {
            if (!(node instanceof Element)) return;
            const grids = Array.from(node.querySelectorAll('.product-list__inner'));
            if (node.matches('.product-list__inner')) grids.push(node);
            grids.forEach(grid => { if (!grid.isConnected) resize.unobserve(grid); });
          });
        });
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      document.addEventListener('shopify:section:load', event => discover(event.target));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["og-period-buy-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('og-period-buy-box')) {
    class OgPeriodBuyBox extends HTMLElement {
      connectedCallback() {
        this.initializeFrame = requestAnimationFrame(() => this.initialize(0));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initializeFrame);
        clearTimeout(this.initializeTimer);
        clearTimeout(this.requestedPlanRestoreTimer);
      }

      initialize(attempt) {
        if (this.initialized || !this.isConnected) return;

        this.form = document.getElementById(this.getAttribute('form-id'));
        this.root = this.closest('.product-form');

        if (!this.form || !this.root) {
          if (attempt < 40) this.initializeTimer = setTimeout(() => this.initialize(attempt + 1), 50);
          return;
        }

        this.initialized = true;
        this.sizeInputs = Array.from(this.querySelectorAll('[data-size-option]'));
        this.sizeCards = Array.from(this.querySelectorAll('[data-size-card]'));
        this.subscriptionInputs = Array.from(this.querySelectorAll('[data-subscription-toggle]'));
        this.message = this.querySelector('[data-buy-box-message]');
        this.subscriptionFallbackMessage = this.querySelector('[data-subscription-fallback-message]')?.textContent.trim() || '';

        this.sizeInputs.forEach((input) => {
          input.addEventListener('change', () => this.selectSize(input.closest('[data-size-card]')));
          input.addEventListener('keydown', (event) => this.activateOnKeyboard(event, input));
        });
        this.subscriptionInputs.forEach((input) => {
          input.addEventListener('change', () => this.selectSubscription(input.closest('[data-size-card]'), input.checked));
          input.addEventListener('keydown', (event) => this.activateOnKeyboard(event, input));
        });
        this.form.addEventListener('variant:changed', (event) => this.syncNativeVariant(event));

        this.refreshCards();
        if (!this.restoreRequestedSellingPlan()) this.syncLoopSelection(0);
      }

      get selectedCard() {
        return this.sizeInputs.find((input) => input.checked)?.closest('[data-size-card]') || null;
      }

      get subscriptionActive() {
        return Boolean(this.selectedCard?.querySelector('[data-subscription-toggle]:checked'));
      }

      activateOnKeyboard(event, input) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        input.click();
      }

      selectSize(card) {
        if (!card) return;

        const wasSubscription = this.subscriptionInputs.some((input) => input.checked);
        this.selectCardInput(card);
        this.clearSubscriptionToggles();
        this.applySellingPlan(false, card);
        this.selectNativeVariant(card);
        this.scheduleSellingPlanSync(card, false);
        this.updateSellingPlanUrl('');

        if (wasSubscription && !card.dataset.subscriptionPlanId) {
          this.setMessage(this.subscriptionFallbackMessage);
        } else {
          this.setMessage('');
        }

        this.refreshCards();
      }

      selectSubscription(card, enabled) {
        if (!card) return;

        const toggle = card.querySelector('[data-subscription-toggle]');
        const canSubscribe = Boolean(card.dataset.subscriptionPlanId && toggle);
        const shouldSubscribe = enabled && canSubscribe;

        this.selectCardInput(card);
        this.clearSubscriptionToggles(toggle);
        if (toggle) toggle.checked = shouldSubscribe;

        if (!shouldSubscribe) this.applySellingPlan(false, card);
        this.updateSellingPlanUrl(shouldSubscribe ? card.dataset.subscriptionPlanId : '');
        this.selectNativeVariant(card);
        this.applySellingPlan(shouldSubscribe, card);
        this.scheduleSellingPlanSync(card, shouldSubscribe);
        this.setMessage('');
        this.refreshCards();
      }

      restoreRequestedSellingPlan(attempt = 0) {
        if (!this.isConnected) {
          clearTimeout(this.requestedPlanRestoreTimer);
          return false;
        }

        const requestedPlanId = new URLSearchParams(window.location.search).get('selling_plan');
        const card = this.selectedCard;
        const toggle = card?.querySelector('[data-subscription-toggle]');

        if (!requestedPlanId || !toggle || requestedPlanId !== card.dataset.subscriptionPlanId) {
          clearTimeout(this.requestedPlanRestoreTimer);
          return false;
        }

        this.clearSubscriptionToggles(toggle);
        toggle.checked = true;
        const selectedPlanMatches = this.getSelectedSellingPlanId() === requestedPlanId;
        const loopSubscription = this.root.querySelector('[data-loop-widget-selling-plan-group]');
        const loopSubscriptionSelected = loopSubscription?.getAttribute('aria-checked') === 'true';
        if (!selectedPlanMatches || !loopSubscriptionSelected) this.applySellingPlan(true, card);
        this.refreshCards();

        // Loop mounts asynchronously and may reset the product form after this component initializes.
        // Keep reconciling the URL-requested plan during that bounded startup window. User changes
        // remove or replace the URL plan immediately, which cancels subsequent reconciliation.
        clearTimeout(this.requestedPlanRestoreTimer);
        if (attempt < 50) {
          this.requestedPlanRestoreTimer = setTimeout(() => this.restoreRequestedSellingPlan(attempt + 1), 100);
        }
        return true;
      }

      updateSellingPlanUrl(planId) {
        if (!window.history.replaceState) return;

        const newUrl = new URL(window.location.href);
        if (planId) {
          newUrl.searchParams.set('selling_plan', planId);
        } else {
          newUrl.searchParams.delete('selling_plan');
        }
        window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());
      }

      selectCardInput(card) {
        const input = card.querySelector('[data-size-option]');
        if (input && !input.disabled) input.checked = true;
      }

      clearSubscriptionToggles(except) {
        this.subscriptionInputs.forEach((input) => {
          if (input !== except) input.checked = false;
        });
      }

      selectNativeVariant(card) {
        const variantId = Number(card.dataset.variantId);
        const formId = this.getAttribute('form-id');
        const picker = this.root.querySelector(`product-variants[form-id="${CSS.escape(formId)}"]`);

        if (picker && typeof picker.selectVariant === 'function') {
          picker.selectVariant(variantId);
          return;
        }

        const idInput = this.form.querySelector('[name="id"]');
        const variant = this.readVariant(card);
        if (!idInput || !variant) return;
        idInput.value = String(variantId);
        this.form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant } }));
      }

      readVariant(card) {
        const script = card.querySelector('[data-variant-json]');
        if (!script) return null;

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          return null;
        }
      }

      syncNativeVariant(event) {
        const variantId = String(event.detail?.variant?.id || '');
        const matchingInput = this.sizeInputs.find((input) => input.value === variantId);
        if (!matchingInput) return;

        const matchingCard = matchingInput.closest('[data-size-card]');
        const matchingToggle = matchingCard?.querySelector('[data-subscription-toggle]');
        const keepSubscription = Boolean(matchingToggle?.checked && matchingCard.dataset.subscriptionPlanId);

        matchingInput.checked = true;
        if (this.restoreRequestedSellingPlan()) return;
        this.clearSubscriptionToggles(keepSubscription ? matchingToggle : null);

        if (!keepSubscription) {
          this.applySellingPlan(false, matchingCard);
          this.scheduleSellingPlanSync(matchingCard, false);
        }

        this.refreshCards();
      }

      applySellingPlan(subscribe, card) {
        const planId = card?.dataset.subscriptionPlanId;
        const loopOnetime = this.root.querySelector('[data-loop-widget-onetime-purchase-option]');
        const loopSubscription = this.root.querySelector('[data-loop-widget-selling-plan-group]');

        if (subscribe && planId) {
          if (loopSubscription && loopSubscription.getAttribute('aria-checked') !== 'true') loopSubscription.click();
          this.setSellingPlan(planId);
        } else {
          if (loopOnetime && loopOnetime.getAttribute('aria-checked') !== 'true') loopOnetime.click();
          this.clearSellingPlans();
        }
      }

      scheduleSellingPlanSync(card, subscribe) {
        const variantId = card?.dataset.variantId;
        const sync = () => {
          if (this.selectedCard?.dataset.variantId !== variantId) return;
          const toggle = card.querySelector('[data-subscription-toggle]');
          const shouldSubscribe = subscribe && Boolean(toggle?.checked);
          this.applySellingPlan(shouldSubscribe, card);
          this.refreshCards();
        };

        requestAnimationFrame(sync);
        setTimeout(sync, 150);
        setTimeout(sync, 400);
      }

      setSellingPlan(planId) {
        const fields = Array.from(this.form.elements).filter((field) => field.name === 'selling_plan');
        const input = this.form.querySelector('#bug-fix-selling-plan');

        fields.forEach((field) => {
          if (field === input) return;
          if (field.type === 'radio' || field.type === 'checkbox') {
            field.checked = false;
          } else if (field.tagName === 'SELECT') {
            field.selectedIndex = -1;
          } else {
            field.value = '';
          }
        });

        if (!input) return;
        input.value = planId;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      clearSellingPlans() {
        Array.from(this.form.elements).forEach((field) => {
          if (field.name !== 'selling_plan') return;
          if (field.type === 'radio' || field.type === 'checkbox') {
            field.checked = false;
          } else if (field.tagName === 'SELECT') {
            field.selectedIndex = -1;
          } else {
            field.value = '';
          }
        });

        const input = this.form.querySelector('#bug-fix-selling-plan');
        if (input) {
          input.value = '';
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      getSelectedSellingPlanId() {
        const checked = Array.from(this.form.elements).find((field) => field.name === 'selling_plan' && field.checked && field.value && field.value !== 'onetime');
        if (checked) return String(checked.value);

        const input = this.form.querySelector('#bug-fix-selling-plan');
        return input?.value ? String(input.value) : '';
      }

      refreshCards() {
        const selectedCard = this.selectedCard;

        this.sizeCards.forEach((card) => {
          const toggle = card.querySelector('[data-subscription-toggle]');
          const useSubscription = card === selectedCard && Boolean(toggle?.checked && card.dataset.subscriptionPlanId);
          const price = useSubscription ? card.dataset.subscriptionPrice : card.dataset.onetimePrice;
          const compare = useSubscription ? card.dataset.subscriptionCompare : card.dataset.onetimeCompare;
          const perCycle = useSubscription ? card.dataset.subscriptionPerCycle : card.dataset.onetimePerCycle;
          const priceElement = card.querySelector('[data-card-price]');
          const compareElement = card.querySelector('[data-card-compare]');
          const perCycleElement = card.querySelector('[data-card-per-cycle]');

          if (priceElement) priceElement.textContent = price || '';
          if (compareElement) {
            compareElement.textContent = compare || '';
            compareElement.hidden = !compare;
          }
          if (perCycleElement) perCycleElement.textContent = perCycle || '';
          card.classList.toggle('is-subscription-active', useSubscription);
        });
      }

      syncLoopSelection(attempt) {
        const card = this.selectedCard;
        if (!card) return;

        const selectedPlanId = this.getSelectedSellingPlanId();
        const selectedLoopOption = this.root.querySelector('.loop-widget-purchase-option[aria-checked="true"], .loop-widget-purchase-option-selected');
        const loopSubscriptionSelected = selectedLoopOption?.matches('[data-loop-widget-selling-plan-group]') || false;
        const planMatchesCard = Boolean(card.dataset.subscriptionPlanId && selectedPlanId === card.dataset.subscriptionPlanId);
        const shouldSubscribe = planMatchesCard || Boolean(loopSubscriptionSelected && card.dataset.subscriptionPlanId);
        const toggle = card.querySelector('[data-subscription-toggle]');

        if (!selectedLoopOption && !selectedPlanId && attempt < 50) {
          setTimeout(() => this.syncLoopSelection(attempt + 1), 100);
          return;
        }

        this.clearSubscriptionToggles(shouldSubscribe ? toggle : null);
        if (toggle) toggle.checked = shouldSubscribe;
        this.applySellingPlan(shouldSubscribe, card);
        this.refreshCards();
      }

      setMessage(message) {
        if (this.message) this.message.textContent = message;
      }
    }

    customElements.define('og-period-buy-box', OgPeriodBuyBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-health-warnings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-health-warnings')) {
    customElements.define('product-health-warnings', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.initialized = true;
        const trigger = this.querySelector('.product-health-warnings__trigger');
        const close = dialog.querySelector('[data-close]');
        trigger.hidden = false;
        this.querySelector('details').hidden = true;
        trigger.addEventListener('click', () => {
          dialog.showModal();
          dialog.querySelector('h2').focus();
        });
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => trigger.focus());
        dialog.addEventListener('click', event => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = Array.from(dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')).filter(element => !element.disabled && element.getClientRects().length);
          const first = controls[0], last = controls[controls.length - 1];
          if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.querySelector('h2'))) {
            event.preventDefault(); last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
